const ldStartTest = () => {
    const observer = new MutationObserver(() => {
        const startButton = document.querySelector('input[name="startQuiz"].wpProQuiz_button');
        if (startButton) {
            startButton.addEventListener('click', () => {
                document.querySelector('.ld-tabs-content')?.style.setProperty('display', 'none', 'important');
            });
            observer.disconnect(); // остановить наблюдение
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
};

export default ldStartTest;
